import { isSafeUri } from './htmlSanitizer';

export function isSafeAudioSrc(src: unknown): src is string {
  if (typeof src !== 'string') return false;
  if (!src.trim()) return false;
  return isSafeUri(src);
}
